import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
} from '@angular/core';
import { SvgIconRegistry } from './icon-registry';

const cssPrefix = 'icon--';
const defaultSvgCss = ['icon-host', 'icon'];

@Component({
  selector: 'nibtravel-icon',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @HostBinding('attr.role') role = 'img';
  @HostBinding('attr.aria-hidden') ariaHidden = true;

  @HostBinding('class') get cssClass() {
    return this.svgClass();
  }

  @Input()
  set icon(value: string) {
    this.#icon = value;
    const icon = this.registry.get(value);

    if (icon) {
      this.element.setAttribute('aria-label', `${value}icon`);
      this.element.innerHTML = icon;
    }
  }

  @Input() size!: string;
  @Input() spacing!: string;
  @Input() state!: string;
  @Input() type!: string;

  @Input()
  set fontSize(value: number | string) {
    this.element.style.fontSize = coerceCssPixelValue(value);
  }

  @Input()
  set color(color: string) {
    this.element.style.color = color;
  }

  #icon!: string;

  constructor(private host: ElementRef, private registry: SvgIconRegistry) {}

  get element() {
    return this.host.nativeElement;
  }

  private svgClass(): string[] {
    const value = [
      ...defaultSvgCss,
      this.cssClassName(this.#icon),
      this.cssClassName(this.size),
      this.cssClassName(this.spacing),
      this.cssClassName(this.state),
      this.cssClassName(this.type),
    ].filter(Boolean);
    return value as string[];
  }

  private cssClassName(value: string): string | undefined {
    return value ? `${cssPrefix}${value}` : undefined;
  }
}

function coerceCssPixelValue(value: any): string {
  if (value == null) {
    return '';
  }

  return typeof value === 'string' ? value : `${value}px`;
}
